<script lang="ts" setup>
// Vue 3 の <script setup> 方式で記述

// 表示・非表示を制御する prop
const props = defineProps<{
  visible: boolean
}>()
</script>

<template>
  <teleport to="body" v-if="visible">
    <div
      class="fixed inset-0 z-[2000] flex items-center justify-center bg-white bg-opacity-50 pointer-events-auto"
    >
      <div class="pointer-events-none z-[2001]">
        <ProgressSpinner />
      </div>
    </div>
  </teleport>
</template>
